export const FRONT = 'FRONT';
export const BACK = 'BACK';